import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';

export default function Loading({ additionalData }: componentTypes.LoadingProps) {
  const { hitsPerPage } = additionalData;

  return (
    <>
      <div className="col-12">
        <div className="card-visual ratio ratio-16x9 small" />
      </div>
      {[...Array(hitsPerPage - 1).keys()].map((i) => (
        <div className="col-12 col-md-6" key={i}>
          <div className="card-visual ratio ratio-16x9 small" />
        </div>
      ))}
    </>
  );
}
